<template>
  <div class="container big-screen">
    <div class="header">
      <img src="../assets/bigscreen/title.png" alt="" />
    </div>

    <div class="content">
      <!-- 统计信息 -->
      <div class="top flex between items-center">
        <!-- <div class="flex items-center">
          <span class="text">项目数量</span>
          <span class="num" v-for="(item, i) in numList" :key="i">{{
            item
          }}</span>

          <span class="text end">个</span>
        </div>
        <div class="flex items-center">
          <span class="text">正在进行中</span>
          <span class="num" v-for="(item, i) in numList" :key="i">{{
            item
          }}</span>
          <span class="text end">个</span>
        </div>
        <div class="flex items-center">
          <span class="text">入驻供应商数量</span>
          <span class="num" v-for="(item, i) in numList" :key="i">{{
            item
          }}</span>
          <span class="text end">家</span>
        </div> -->

        <div class="text" id="scroll">
          欢迎各位参与，请遵守竞价规则，保持安静，手机调至静音状态或关机！
        </div>
      </div>

      <!-- 竞价信息 -->
      <div class="jingjia">
        <div class="title flex flex-center items-center">竞价信息</div>
        <div class="table-data">
          <el-row>
            <el-col :span="8"
              ><div class="name text-center">项目名称</div></el-col
            >
            <el-col :span="3"
              ><div class="name text-center">场次号</div></el-col
            >
            <el-col :span="3"
              ><div class="name text-center">参与方式</div></el-col
            >
            <el-col :span="3"
              ><div class="name text-center">出价方式</div></el-col
            >
            <el-col :span="3"
              ><div class="name text-center">竞价开始时间</div></el-col
            >
            <el-col :span="3"
              ><div class="name text-center">竞价结束时间</div></el-col
            >
          </el-row>

          <el-row
            class="data pointer"
            :class="i == active ? 'active' : ''"
            v-for="(item, i) in jingJiaList"
            :key="i"
          >
            <el-col :span="8"
              ><div class="name1 text-center">{{ item.title }}</div></el-col
            >
            <el-col :span="3"
              ><div class="name1 text-center">
                {{ item.sessionNum }}
              </div></el-col
            >
            <el-col :span="3"
              ><div class="name1 text-center">
                {{ item.participationMode == 1 ? "公开" : "非公开" }}
              </div></el-col
            >
            <el-col :span="3"
              ><div class="name1 text-center">
                {{ item.biddingMode == 1 ? "连续报价" : "连续报价" }}
              </div></el-col
            >
            <el-col :span="3"
              ><div class="name1 text-center">{{ item.beginTime }}</div></el-col
            >
            <el-col :span="3"
              ><div class="name1 text-center">{{ item.endTime }}</div></el-col
            >
          </el-row>
        </div>
      </div>

      <!-- 竞价记录和竞价趋势 -->

      <el-row :gutter="20" class="jilu-qushi">
        <el-col :span="16">
          <div class="jilu">
            <div class="biaoti flex items-center">
              <span class="title1">竞价记录</span>
              <div v-if="jingJiaList && jingJiaList.length > 0">
                <span class="xiangmu">【{{ jingJiaList[active].title }}】</span>
              </div>

              <span class="xiangmu"></span>
            </div>

            <!-- 下面内容 -->
            <div class="bottom-content">
              <el-row class="toubu">
                <el-col :span="10">
                  <el-row>
                    <el-col :span="6" :offset="18">倒计时</el-col>
                  </el-row>
                </el-col>
                <el-col :span="14">
                  <el-row>
                    <el-col :span="6">序号</el-col>
                    <el-col :span="6">报价人</el-col>
                    <el-col :span="6">报价金额(元)</el-col>
                    <el-col :span="6">报价时间</el-col>
                  </el-row>
                </el-col>
              </el-row>
              <div v-if="currentFenBao.length > 0">
                <div
                  style="margin-top: 10px"
                  v-for="(item, i) in currentFenBao"
                  :key="i"
                >
                  <el-row class="item-list flex items-center">
                    <el-col :span="10">
                      <el-row>
                        <el-col :span="18">
                          <div class="flex items-center">
                            <span class="fenbao">{{ item.subTitle }}</span>
                            <div class="fenge"></div>
                            <div class="flex flex-column price-name">
                              <p>
                                当前最低报价:
                                <span style="font-size: 0.3rem" v-format="'#,###.##'">{{
                                  item.lowQuotePrice
                                }}</span>
                              </p>
                              <p v-if="item.lowQuoteSupplier">
                                报价人:{{ item.lowQuoteSupplier }}号报价人
                              </p>
                              <p v-else>报价人:</p>
                            </div>
                          </div>
                        </el-col>
                        <el-col :span="6">
                          <div
                            class="flex items-center flex-center"
                            v-if="jingJiaList.length > 0"
                          >
                            <div
                              v-if="
                                jingJiaList[active].status == 3 ||
                                jingJiaList[active].status == 4
                              "
                              class="flex items-center"
                            >
                              <ms
                                @change="msChange($event, item, i)"
                                v-if="item.endFlag == 0"
                                class="num"
                                :time="item.daoJiShi"
                                @success="timeEnd(item, i)"
                              ></ms>
                              <span v-if="item.endFlag == 0">秒</span>
                              <div v-if="item.endFlag == 1" class="num">
                                已结束
                              </div>
                            </div>

                            <span
                              v-if="jingJiaList[active].status == 2"
                              class="num"
                              >准备中</span
                            >
                            <span
                              v-if="jingJiaList[active].status == 1"
                              class="num"
                              >未开始</span
                            >
                            <span
                              v-if="jingJiaList[active].status == 5"
                              class="num"
                              >已结束</span
                            >
                          </div>
                        </el-col>
                      </el-row>
                    </el-col>

                    <el-col :span="14">
                      <div
                        class="row-height"
                        v-for="(subItem, i) in item.biddingRecordsList"
                        :key="i"
                      >
                        <el-row
                          v-if="
                            subItem.biddingId == jingJiaList[active].id &&
                            subItem.subId == item.id
                          "
                        >
                          <el-col :span="6"
                            ><div class="xuhao">{{ i + 1 }}</div>
                          </el-col>
                          <el-col :span="6"
                            ><div class="mingzi">
                              {{ subItem.bidderNum }}号报价人
                            </div>
                          </el-col>
                          <el-col :span="6"
                            ><div class="price" v-format="'#,###.##'">
                              {{ subItem.bidAmount }}
                            </div>
                          </el-col>
                          <el-col :span="6"
                            ><div class="date">{{ subItem.bidTime }}</div>
                          </el-col>
                        </el-row>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="qushi">
            <div class="biaoti" v-if="subTitle">竞价趋势 - {{ subTitle }}</div>
            <div class="biaoti" v-else>竞价趋势</div>
            <div id="qushi"></div>
            <div
              class="reset el-icon-refresh-right"
              @click="getOnRunJingJia"
            ></div>
          </div>
        </el-col>
      </el-row>
    </div>

    <!-- 登录框 -->
    <div class="login-box-bg" v-if="!isLoginShow">
      <el-card class="login-box">
        <el-tabs v-model="activeName">
          <el-tab-pane label="会员登录" name="first">
            <el-form
              :model="loginForm"
              :rules="loginFormRules"
              ref="loginFormRef"
            >
              <el-form-item prop="userName">
                <el-input
                  @blur="inputBlur"
                  v-model="loginForm.userName"
                  placeholder="请输入用户名"
                  class="input-with-select"
                >
                  <template slot="prepend">
                    <div>
                      <img src="../assets/images/me.png" alt="" />
                    </div>
                  </template>
                </el-input>
              </el-form-item>
              <el-form-item prop="password">
                <el-input
                  @input="inputBlur"
                  v-model="loginForm.password"
                  placeholder="请输入密码"
                  type="password"
                  class="input-with-select"
                >
                  <template slot="prepend">
                    <div>
                      <img src="../assets/images/pwd.png" alt="" />
                    </div>
                  </template>
                </el-input>
              </el-form-item>

              <el-form-item>
                <el-button
                  @click="loginBtn"
                  :disabled="isLogin"
                  type="primary"
                  class="w100"
                  >登录</el-button
                >
              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </el-card>
    </div>

    <Result
      :title="resultTitle"
      :SubTitle="subTitle1"
      :isShow="resultShow"
      @change="resultClose"
    />
  </div>
</template>

<script>
import ms from "../components/ms.vue";
import Result from "../components/Result.vue";

(function flexible(window, document) {
  var docEl = document.documentElement;
  var dpr = window.devicePixelRatio || 1;

  // adjust body font size
  function setBodyFontSize() {
    if (document.body) {
      document.body.style.fontSize = 12 * dpr + "px";
    } else {
      document.addEventListener("DOMContentLoaded", setBodyFontSize);
    }
  }
  setBodyFontSize();

  // set 1rem = viewWidth / 10
  function setRemUnit() {
    var rem = docEl.clientWidth / 24; // 这里默认是10等份，手动改为24，此时1rem=1920/24px即80px。（设计稿是1920px的）
    docEl.style.fontSize = rem + "px";
  }

  setRemUnit();

  // reset rem unit on page resize
  window.addEventListener("resize", setRemUnit);
  window.addEventListener("pageshow", function (e) {
    if (e.persisted) {
      setRemUnit();
    }
  });

  // detect 0.5px supports
  if (dpr >= 2) {
    var fakeBody = document.createElement("body");
    var testElement = document.createElement("div");
    testElement.style.border = ".5px solid transparent";
    fakeBody.appendChild(testElement);
    docEl.appendChild(fakeBody);
    if (testElement.offsetHeight === 1) {
      docEl.classList.add("hairlines");
    }
    docEl.removeChild(fakeBody);
  }
})(window, document);
import echarts from "echarts";

export default {
  components: { ms, Result },
  data() {
    return {
      resultTitle: "",
      subTitle1: "",
      resultShow: false,
      isLoginShow: window.sessionStorage.getItem("isLoginShow"),
      activeName: "first",
      loginForm: {
        userName: null,
        password: null,
      },
      loginFormRules: {
        userName: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      active: 0,

      //列表查询信息
      queryInfo: {
        title: null,
        publishCompany: null,
        participationMode: null,
        pageNum: 1,
        pageSize: 3,
        params: {
          beginBeginTime: null,
        },
      },
      //竞价ID
      bid: null,
      //竞价信息列表
      jingJiaList: [],
      //竞价标题
      title: null,
      //分包信息
      fenBaoList: [],
      //报价记录
      jiLuList: [],
      //趋势图的时间
      time: [],
      //趋势图的数据
      data: [],
      numList: [], //存储头部的数字
      timer: null, //定时器
      quShiTimer: null, //趋势的定时器
      quShiTimeInterVal: 60000, //趋势的间隔秒数
      currentFenBao: [], //当前分包的数据
      fenBaoActive: 0, //当前分包的下标
      subTitle: "", //分包标题
      timeer11: null,
      jjStatus: "",
      isLogin: true,
      timerActive: null,
    };
  },
  created() {},
  mounted() {
    if (this.isLoginShow) {
      document.addEventListener("visibilitychange", this.handleWindowChange);

      //正在进行中的竞价
      this.getOnRunJingJia();
      //初始化socket
      this.socketInit();
      // //数字转化为数组
      // this.numberOrArray(1205);

      //每隔1分更新数据
      this.IntervalTime();
      //每隔5分钟切换选中项
      this.changeActive();
      //每隔1分切换趋势
      this.quShiInterval();
    }
    this.move();
  },
  methods: {
    //浏览器窗口隐藏显示变换
    handleWindowChange(e) {
      switch (e.target.visibilityState) {
        case "prerender":
          break;
        case "hidden":
          break;
        case "visible":
          this.getCurrentTime();
          break;
      }
    },
    resultClose() {
      this.resultShow = false;
    },
    //点击登录
    async loginBtn() {
      const { data: res } = await this.$axios.get("/api/biddingScreen/login", {
        params: this.loginForm,
      });
      if (res.code == 200) {
        window.sessionStorage.setItem("isLoginShow", true);
        this.isLoginShow = true;
        //正在进行中的竞价
        this.getOnRunJingJia();
        //初始化socket
        this.socketInit();
        // //数字转化为数组
        // this.numberOrArray(1205);

        //每隔1分更新数据
        this.IntervalTime();
        //每隔5分钟切换选中项
        this.changeActive();
        //每隔1分切换趋势
        this.quShiInterval();
      } else {
        this.resultTitle = "登录失败";
        this.subTitle1 = res.msg;
        this.resultShow = true;
      }
    },
    //用户名和密码框是去焦点
    inputBlur() {
      if (this.loginForm.userName && this.loginForm.password) {
        this.isLogin = false;
      }
    },
    msChange(val, item, i) {
      item.daoJiShi = val;
      this.currentFenBao.splice(i, 1, item);
    },
    move() {
      // clearInterval(this.timeer11);
      let width = document.getElementById("scroll").scrollWidth;
      let scroll = document.getElementById("scroll");
      let speed = 10; // 位移距离
      this.timeer11 = setInterval(function () {
        speed = speed - 1;
        // 如果位移超过文字宽度，则回到起点

        if (-speed >= width * 2) {
          speed = width;
        }
        scroll.style.transform = "translateX(" + speed + "px)";
      }, 40);
    },
    //倒计时结束
    timeEnd() {
      // time.endFlag = 1;
      // this.currentFenBao.splice(i, 1, time);
      this.getOnRunJingJia();
    },
    //歌5分更新竞价列表
    IntervalTime() {
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        // this.fenBaoActive = 0;

        this.getOnRunJingJia();
      }, 60000);
    },
    changeActive() {
      clearInterval(this.timerActive);

      this.timerActive = setInterval(() => {
        // console.log(this.active);

        if (this.jingJiaList.length > 1) {
          this.active++;
          if (!(this.active < this.jingJiaList.length)) {
            this.active = 0;
          }
        }
      }, 300000);
    },
    // 将数字转为数组
    numberOrArray(num) {
      num = num + "";
      this.numList = num.split("");
    },
    //WebSockte初始化
    socketInit() {
      if (typeof WebSocket === "undefined") {
        this.resultTitle = "socket链接失败";
        this.subTitle1 = "您的浏览器不支持socket,请升级浏览器";
        this.resultShow = true;
        return;
      } else {
        // 实例化socket
        this.socket = new WebSocket(
          // "ws://81.70.253.119:8081/websocket/message"
		  this.$static.SERVER_WS + "/websocket/message"
        );
        // 监听socket连接
        this.socket.onopen = this.open;
        // 监听socket错误信息
        this.socket.onerror = this.error;
      }
    },
    //获取socket信息
    getMessage(msg) {
      if (msg.data != "连接成功") {
        let data = JSON.parse(msg.data);
        // console.log(data);
        if (data.bidTime) {
          data.bidTime = data.bidTime.substr(10, 16);
        }
        if (data.biddingId == this.jingJiaList[this.active].id) {
          this.getOnRunJingJia();
          //    //判断是否本次竞价结束
          // if (data.biddingEnd && data.biddingEnd == 1) {
          //   this.getOnRunJingJia();
          // }
          // if (data.biddingAcc && data.biddingAcc == 1) {
          //   this.jjStatus = 4;
          // }
          // this.currentFenBao.forEach((item, i) => {
          //   if (data.bidAmount && data.bidderNum) {
          //     this.jiLuList.unshift(data);
          //   }
          //   if (item.id == data.subId) {
          //     item.daoJiShi = item.biddingTime;
          //     item.biddingRecordsList.unshift(data);
          //     let index = 0;
          //     if (this.currentFenBao.length == 1) {
          //       index = 8;
          //     } else if (this.currentFenBao.length == 2) {
          //       index = 4;
          //     } else {
          //       index = 2;
          //     }
          //     item.biddingRecordsList = item.biddingRecordsList.splice(
          //       0,
          //       index
          //     );
          //     this.currentFenBao.splice(i, 1, item);
          //   }
          // });
        }
      }
    },
    //获取正在进行中的倒计时
    async getCurrentTime() {
      const { data: res } = await this.$axios.get(
        "/api/biddingInfo/getBiddingCountdown",
        {
          params: {
            biddingId: this.jingJiaList[this.active].id,
          },
          headers: {
            token: window.sessionStorage.getItem("token"),
          },
        }
      );
      // console.log(res.data);
      if (res.code == 200) {
        for (var key in res.data) {
          this.currentFenBao.some((item, i) => {
            if (key == item.id) {
              item.daoJiShi = res.data[key];
              this.currentFenBao.splice(i, 1, item);
            }
          });
        }
      }
    },
    // 打开socket链接
    open() {
      // 监听socket消息
      // console.log("链接成功");
      this.socket.onmessage = this.getMessage;
    },
    //socket错误
    error() {
      // console.log("连接错误");
    },
    close() {
      // console.log("socket已经关闭");
    },

    //获取报价记录
    getQuShi() {
      // console.log(this.fenBaoActive);
      let time = [];
      let data = [];
      this.subTitle = "";
      echarts.init(document.getElementById("qushi")).dispose();
      let qushi = echarts.init(document.getElementById("qushi"));
      this.jiLuList.some((item) => {
        if (item.subId == this.currentFenBao[this.fenBaoActive].id) {
          this.subTitle = item.subTitle;
          time.unshift(item.bidTime);
          data.unshift(item.bidAmount);
        }
      });

      // if (
      //   this.currentFenBao[this.fenBaoActive] &&
      //   this.currentFenBao[this.fenBaoActive].biddingRecordsList
      // ) {
      //   this.currentFenBao[this.fenBaoActive].biddingRecordsList.forEach(
      //     (item) => {
      //       time.push(item.bidTime);
      //       data.push(item.bidAmount);
      //     }
      //   );
      // }

      var option = {
        grid: {
          left: "2%",
          top: "5%",
          right: "7%",
          bottom: "2%",
          containLabel: true,
        },
        tooltip: {
          trigger: "axis",
        },
        color: ["#57c2f6"],
        textStyle: {
          color: "#fff",
        },
        xAxis: {
          type: "category",
          boundaryGap: false,

          data: time,
        },
        yAxis: {
          type: "value",

          splitLine: {
            show: false,
          },
        },
        series: [
          {
            data: data,
            type: "line",
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#29628c" },
                  // { offset: 0.5, color: "pink" },
                  { offset: 1, color: "#031b46" },
                ]),
              },
              // color: {
              //   type: "linear",
              //   colorStops: [
              //     {
              //       offset: 0,
              //       color: "#29628c", // 100% 处的颜色
              //     },
              //     {
              //       offset: 1,
              //       color: "#031b46", //   0% 处的颜色
              //     },
              //   ],
              // },
            },
            symbol: "none", //去掉拐点的圆圈
            smooth: true, //是否为圆滑曲线
          },
        ],
      };
      //使用刚刚指定的配置项和数据项显示图表
      qushi.setOption(option);
    },

    //获取正在进行中的竞价信息
    async getOnRunJingJia() {
      // clearInterval(this.timer);
      // clearInterval(this.quShiTimer);
      // clearInterval(this.timeer11);
      const { data: res } = await this.$axios.get(
        "/api/biddingScreen/getBiddingList"
      );
      if (res.code == 200) {
        this.jingJiaData = res.data;
        if (res.data.length == 0) {
          this.active = 0;
          this.fenBaoActive = 0;
          this.jingJiaList = [];
          this.currentFenBao = [];
          this.jiLuList = [];
          this.getQuShi();
        }
        if (res.data.length && res.data.length > 6) {
          this.jingJiaList = res.data.splice(0, 6);
        } else {
          this.jingJiaList = res.data;
        }
        // this.jingJiaList =
        //   res.data.length > 6 ? res.data.splice(0, 6) : res.data;
        this.fenBaoList = [];
        this.jiLuList = [];

        if (this.jingJiaList.length > 0) {
          this.jingJiaList.some((item) => {
            item.subDetailList.some((subItem) => {
              this.fenBaoList.push(subItem);
              subItem.biddingRecordsList.some((childItem) => {
                childItem.bidTime = childItem.bidTime.substr(10, 16);
                this.jiLuList.push(childItem);
              });
              let index = 0;
              if (item.subDetailList.length == 1) {
                index = 6;
              } else if (item.subDetailList.length == 2) {
                index = 3;
              } else {
                index = 2;
              }
              if (subItem.biddingRecordsList.length > 2) {
                subItem.biddingRecordsList = subItem.biddingRecordsList.slice(
                  0,
                  index
                );
              }
            });
          });

          this.getIdSelcetCurrent();
          this.getQuShi(); //调用趋势列表图
          this.getCurrentTime();
        }
        // if (this.jingJiaList.length == 0) {

        // } else {
        //   this.jiLuList = [];
        //   res.data.forEach((item) => {
        //     item.subDetailList.forEach((subItem) => {
        //       subItem.biddingRecordsList.forEach((childItem) => {
        //         childItem.bidTime = childItem.bidTime.substr(10);
        //         this.jiLuList.push(childItem);
        //       });
        //     });
        //   });
        //   this.jingJiaList = this.pinZhuangData(this.jingJiaList, res.data);
        //   this.getIdSelcetCurrent(); //通过竞价ID为当前分包赋值
        //   this.getQuShi(); //调用趋势列表图
        // }
      }
    },
    //每隔一分钟趋势图针对当前分包更新一次
    quShiInterval() {
      clearInterval(this.quShiTimer);
      this.quShiTimer = setInterval(() => {
        if (this.currentFenBao.length > 1) {
          this.fenBaoActive++;
          if (this.fenBaoActive < this.currentFenBao.length) {
            this.getQuShi();
          } else {
            this.fenBaoActive = 0;
            this.getQuShi();
          }
        } else {
          this.fenBaoActive = 0;
          this.getQuShi();
        }
      }, this.quShiTimeInterVal);
    },
    //回来新数据进行拼装
    pinZhuangData(oldArr, newArr) {
      if (newArr && newArr.length && newArr.length > 0) {
        //新回来的数据，现在数据中没有的
        const result = [];
        newArr.forEach((item) => {
          let flag = true;
          oldArr.forEach((subItem) => {
            if (item.id == subItem.id) {
              flag = false;
            }
          });
          if (flag) {
            result.push(item);
          }
        });
        //原来的数据中，需要删除的数据
        oldArr.forEach((item, i) => {
          let flag = true;
          newArr.forEach((subItem) => {
            if (item.id == subItem.id) {
              flag = false;
            }
          });
          if (flag) {
            oldArr.splice(i, 1);
          }
        });
        oldArr = oldArr.concat(result);
        return oldArr;
      } else {
        return;
      }
    },
    //根据现在选中的竞价ID选出分包数据和报价记录数据
    getIdSelcetCurrent() {
      this.currentFenBao = [];
      // this.fenBaoActive = 0;
      if (!(this.active < this.jingJiaList.length)) {
        this.active = 0;
      }
      if (this.fenBaoList && this.fenBaoList.length > 0) {
        this.fenBaoList.some((item) => {
          if (this.jingJiaList[this.active].id == item.biddingId) {
            if (item.subTitle.length > 5) {
              item.subTitle = item.subTitle.substr(0, 5) + "...";
            }
            this.currentFenBao.push(item);
          }
        });
      }
    },
  },

  destroyed() {
    clearInterval(this.timer);
    clearInterval(this.quShiTimer);
    clearInterval(this.timerActive);
    document.removeEventListener("visibilitychange", this.handleWindowChange);

    // clearInterval(this.timeer11);
    this.socket.onclose = this.close();
  },
};
</script>

<style lang="less" scoped>
* {
  box-sizing: border-box;
}
.login-box-bg {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  .login-box {
    width: 410px;
    height: 360px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    box-sizing: border-box;
    padding-left: 30px;
    padding-right: 30px;
    padding-top: 30px;
    .set-pwd {
      color: #95b3db;
    }
    .register {
      color: #3b426b;
    }
    .text {
      color: #ccd9e9;
      line-height: 14px;
    }
    .text1 {
      color: #3b426b;
      line-height: 14px;
    }
    .code {
      font-size: 14px;
      color: #3b426b;
    }
  }
  /deep/.login-box.el-card.is-always-shadow {
    box-shadow: 0px 0px 15px rgba(28, 101, 196, 0.3);
  }
  /deep/.el-tabs__nav-wrap::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 0px;
    background-color: #e4e7ed;
    z-index: 1;
  }
  /deep/.el-tabs__active-bar {
    width: 16px !important;
    // transform: translateX(100%) !important;
    margin-left: 30px;
    background-color: #1c65c4;
  }
  /deep/.el-tabs__item.is-active {
    color: #02224b;
  }
  /deep/.el-tabs__item {
    color: #ccd9e9;
    font-size: 18px;
  }
  /deep/.el-input-group__prepend {
    background-color: #ccd9e9;
    padding: 0 12px;
    padding-top: 6px;
  }
  /deep/.el-input__inner {
    background-color: #f7f9fc;
    border: none;
    font-size: 14px;
    // color: #ccd9e9;
  }
}
.row-height {
  letter-spacing: 0.025rem;
}
.row-height + .row-height {
  margin-top: 0.075rem;
}

.container {
  width: 100%;
  height: 13.5rem;
  overflow: hidden;
  background-image: url(../assets/bigscreen/bg.png);
  background-size: 100% 100%;
  .header {
    display: flex;
    justify-content: center;
    height: 1.125rem;
    align-items: center;
    img {
      width: 2.625rem;
      height: 0.625rem;
      margin-top: 0.125rem;
    }
  }

  .content {
    padding: 0 0.5rem;
    margin-top: 0.25rem;
    .top {
      position: relative;
      height: 0.375rem;
      width: 100%;
      #scroll {
        position: absolute;
        right: 0;
        line-height: 0.375rem;
        height: 0.375rem;
      }
      .text {
        font-size: 0.325rem;
        color: #4283e5;
        font-weight: bold;
      }
      .num {
        color: #55cefe;
        font-size: 0.325rem;
        font-weight: bold;
        width: 0.5rem;
        height: 0.6875rem;
        line-height: 0.6875rem;
        text-align: center;
        background-image: url(../assets/bigscreen/text-bg.png);
        background-size: 100% 100%;
        margin-left: 0.125rem;
      }
      .end {
        margin-left: 0.125rem;
      }
    }

    // 竞价信息
    .jingjia {
      // margin-top: 0.25rem;
      // height: 3.5rem;
      height: 4.75rem;
      background-image: url(../assets/bigscreen/jingjiaxinxi.png);
      background-size: 100% 100%;
      padding-top: 0.25rem;
      .title {
        color: #13aed9;
        font-size: 0.275rem;
        font-weight: bold;
        line-height: 0.8rem;
      }
      .table-data {
        // margin-top: 0.4375rem;
        // height: 2.25rem;
        height: 3.5rem;
        // overflow-y: scroll;
        .name {
          color: #55aad9;
          font-weight: bold;
          font-size: 0.275rem;
          width: 100%;
        }
        .name1 {
          font-weight: normal;
          font-size: 0.175rem;
          color: #55aad9;
          line-height: 0.5625rem;
        }
        .data {
          height: 0.5625rem;
        }
        .active {
          background-image: url(../assets/bigscreen/jingjia-item.png);
          background-repeat: no-repeat;
          background-size: 100% 100%;
        }
      }
    }

    // 记录和趋势
    .jilu-qushi {
      // height: 6.75rem;
      height: 5.5rem;

      margin-top: 0.5rem;
      .jilu {
        width: 100%;
        // height: 6.75rem;
        height: 6.2rem;
        background-image: url(../assets/bigscreen/jilu.png);
        background-size: 100% 100%;
        padding-left: 0.45rem;
        padding-top: 0.375rem;
        box-sizing: border-box;
        .biaoti {
          font-weight: bold;
          font-size: 0.275rem;
          .title1 {
            color: #25a9cb;
          }
          .xiangmu {
            color: #fff;
            margin-left: 0.375rem;
          }
        }

        //下面内容
        .bottom-content {
          margin-top: 0.25rem;
          padding: 0.25rem;
          .toubu {
            color: #4ab2e6;
            font-size: 0.25rem;
            font-weight: bold;
            text-align: center;
          }
          .item-list {
            color: #fff;
            text-align: center;
            padding: 0.25rem 0.125rem;
            border-top: 2px solid #0a2b73;
            .fenbao {
              font-size: 0.275rem;
              font-weight: bold;
              width: 1.2rem;
            }
            .fenge {
              width: 0.1875rem;
              height: 0.025rem;
              background-color: #0a2b73;
              margin: 0 0.125rem;
            }
            .price-name {
              p {
                text-align: left;
                font-size: 0.275rem;
                font-weight: bold;
              }
              p + p {
                margin-top: 0.0625rem;
              }
            }

            .num {
              font-size: 0.325rem;
              font-weight: bold;
              color: rgb(255, 0, 0);
              margin-right: 0.025rem;
            }
            .num,
            .xuhao,
            .mingzi,
            .price,
            .date {
              line-height: 1.5em;
            }
            .xuhao + .xuhao {
              margin-top: 0.25rem;
            }
            .mingzi + .mingzi {
              margin-top: 0.25rem;
            }
            .price + .price {
              margin-top: 0.25rem;
            }

            .date + .date {
              margin-top: 0.25rem;
            }
          }
        }
      }
      .qushi {
        width: 100%;
        // height: 6.75rem;
        height: 6.2rem;
        position: relative;
        background-image: url(../assets/bigscreen/qushi.png);
        background-size: 100% 100%;
        padding-left: 0.45rem;
        padding-top: 0.375rem;
        box-sizing: border-box;
        .reset {
          // width: 1.25rem;
          // height: 0.5rem;
          padding: 0.125rem 0.25rem;
          line-height: 0.5rem;
          font-size: 0.3rem;
          color: #4283e5;
          position: absolute;
          z-index: 10000;
          text-align: center;
          right: 0;
          bottom: 0;
          // background: #4283e5;
          opacity: 0.3;
          cursor: pointer;
        }
        .biaoti {
          font-weight: bold;
          font-size: 0.275rem;
          color: #25a9cb;
        }
        #qushi {
          margin-top: 0.5rem;
          padding-right: 0.625rem;
          // height: 4.5rem;
          height: 3.75rem;
        }
      }
    }
  }
}
</style>